import axios from 'axios';

import { apiBaseUrl, apiKey } from '../../app/options';

export const headers = {
  'Content-Type': 'application/json',
  'x-api-key': apiKey
};

export const getPdf = async (url: string, data: any) => {
  const d = await (await axios.post(`${apiBaseUrl}/${url}`, data, { headers })).data;
  return d;
};
